import { subscriptionsApi } from 'api'
import { ProcessingKey } from 'constants/rootConstants'
import {
  isFunnelsConfigReady,
  prefetchWalletPayment,
  setDefaultSelectedPlan,
} from 'helpers/prefetchWalletPayment'
import { OnboardingType } from 'models/lead.model'
import { useZustandStore } from 'zustandGlobalStore'

export const fetchPlans = async (): Promise<void> => {
  const cohortLeadId = useZustandStore.getState().lead?.cohortLeadId

  if (!cohortLeadId) return

  useZustandStore.getState().startProcessing(ProcessingKey.FETCH_PLANS)

  const response = await subscriptionsApi.getPlans(cohortLeadId)

  if (response?.data && response?.success) {
    useZustandStore.setState({
      cohortLeadPlans: response.data.plans,
      cohortLeadCurrency: response.data.currency,
    })
    setDefaultSelectedPlan(OnboardingType.PURCHASE)
    if (isFunnelsConfigReady()) {
      void prefetchWalletPayment(OnboardingType.PURCHASE)
    }
  }

  useZustandStore.getState().stopProcessing(ProcessingKey.FETCH_PLANS)
}
